<div class="modal-overlay">
  <div class="modal-container">
    <!-- Header -->
    <div class="modal-header">
      <div class="header-content">
        <div class="icon-wrapper">
          <fa-icon [icon]="faHandshake"></fa-icon>
        </div>
        <div>
          <h2 class="modal-title">Editar Partner</h2>
          <p class="modal-subtitle">{{ partner.company_name }}</p>
        </div>
      </div>
      <button class="btn-close" (click)="onClose()">
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
    </div>

    <!-- Content -->
    <div class="modal-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="partner-form">
        <div class="section-divider section-divider--first">
          <fa-icon [icon]="faTags"></fa-icon>
          <span>Clasificación</span>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Partner Type -->
          <div class="form-group">
            <label
              for="type"
              class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1"
            >
              Tipo de Partner *
            </label>
            <app-custom-select
              id="type"
              formControlName="type"
              [options]="typeOptions"
              [small]="true"
              [showIcon]="false"
              placeholder="-- Seleccionar tipo --"
            ></app-custom-select>
            @if (form.get('type')?.touched && form.get('type')?.invalid) {
              <p class="error-text">El tipo de partner es obligatorio</p>
            }
          </div>

          <!-- Relationship Model -->
          <div class="form-group">
            <label
              for="relationship_type"
              class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1 label-with-info"
            >
              Modelo de Relación
              <button
                type="button"
                class="info-icon-btn"
                (click)="openRelationshipInfoModal()"
                aria-label="Información sobre los modelos de relación"
              >
                <fa-icon [icon]="faCircleInfo"></fa-icon>
              </button>
            </label>
            <app-custom-select
              id="relationship_type"
              formControlName="relationship_type"
              [options]="relationshipTypeOptions"
              [small]="true"
              [showIcon]="false"
              placeholder="-- Sin cambios --"
            ></app-custom-select>
          </div>

          @if (isDistribuidor) {
            <div class="form-group">
              <label
                for="distribution_modality"
                class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1"
              >
                Modelo de Distribución *
              </label>
              <app-custom-select
                id="distribution_modality"
                formControlName="distribution_modality"
                [options]="distributionModalityOptions"
                [small]="true"
                [showIcon]="false"
                placeholder="-- Seleccionar modelo --"
              ></app-custom-select>
              @if (
                form.get('distribution_modality')?.touched &&
                form.get('distribution_modality')?.invalid
              ) {
                <p class="error-text">El modelo de distribución es obligatorio</p>
              }
            </div>
          }
        </div>

        <!-- Comments -->
        <div class="form-group mt-4">
          <div class="flex items-baseline justify-between mb-1">
            <label for="comments" class="text-sm font-semibold text-slate-700 dark:text-slate-300">
              Comentarios
            </label>
            <span class="text-xs text-slate-400"
              >{{ form.get('comments')?.value?.length || 0 }}/{{ commentsMaxLength }}</span
            >
          </div>
          <textarea
            id="comments"
            formControlName="comments"
            class="app-input"
            rows="2"
            maxlength="500"
            placeholder="Comentarios adicionales sobre el partner..."
          ></textarea>
        </div>

        @if (isColaborador) {
          <div class="section-divider">
            <fa-icon [icon]="faGaugeHigh"></fa-icon>
            <span>Condiciones Generales</span>
          </div>

          <div class="alert-info">
            <fa-icon [icon]="faCircleInfo" class="mr-2"></fa-icon>
            <div>
              <p class="text-xs leading-relaxed mb-2">
                El modelo Colaborador no tiene condiciones económicas asociadas.
              </p>
              <dl class="collaborator-conditions">
                <div class="collaborator-conditions__item">
                  <dt>Comisión</dt>
                  <dd>No aplica</dd>
                </div>
                <div class="collaborator-conditions__item">
                  <dt>Exclusividad</dt>
                  <dd>No</dd>
                </div>
                <div class="collaborator-conditions__item">
                  <dt>Objetivo mínimo</dt>
                  <dd>No</dd>
                </div>
                <div class="collaborator-conditions__item">
                  <dt>Relación comercial obligatoria</dt>
                  <dd>No</dd>
                </div>
                <div class="collaborator-conditions__item">
                  <dt>Seguimiento</dt>
                  <dd>Según necesidad</dd>
                </div>
              </dl>
            </div>
          </div>
        } @else {
          <div class="section-divider">
            <fa-icon [icon]="faPercent"></fa-icon>
            <span>Comisiones</span>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- License Commission -->
            <div class="form-group">
              <label
                for="fixed_commission"
                class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1"
              >
                Comisiones fijas (%)
              </label>
              <div class="relative">
                <input
                  type="number"
                  id="fixed_commission"
                  formControlName="fixed_commission"
                  class="app-input pr-10"
                  placeholder="Por producto"
                />
                <div class="input-icon">
                  <fa-icon [icon]="faPercent"></fa-icon>
                </div>
              </div>
              @if (
                form.get('fixed_commission')?.touched && form.get('fixed_commission')?.invalid
              ) {
                <p class="error-text">Valor entre 0 y 100</p>
              }
              <p class="hint-text">Sobre proyectos e implantaciones.</p>
            </div>

            <!-- Services Maintenance Commission -->
            <div class="form-group">
              <label
                for="recurring_commission"
                class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1"
              >
                Comisiones recurrentes (%) *
              </label>
              <div class="relative">
                <input
                  type="number"
                  id="recurring_commission"
                  formControlName="recurring_commission"
                  class="app-input pr-10"
                  placeholder="Ej: 5"
                />
                <div class="input-icon">
                  <fa-icon [icon]="faPercent"></fa-icon>
                </div>
              </div>
              @if (
                form.get('recurring_commission')?.touched &&
                form.get('recurring_commission')?.invalid
              ) {
                <p class="error-text">Valor obligatorio entre 0 y 100</p>
              }
              <p class="hint-text">Sobre servicios recurrentes según condiciones vigentes.</p>
            </div>
          </div>

          <div class="alert-info mt-4">
            <fa-icon [icon]="faCircleInfo" class="mr-2"></fa-icon>
            <p class="text-xs leading-relaxed">
              Algunos productos pueden tener comisiones especiales configuradas de forma
              individual, que prevalecerán sobre la comisión fija que tenga el partner.
            </p>
          </div>

          <div class="section-divider">
            <fa-icon [icon]="faGaugeHigh"></fa-icon>
            <span>Condiciones Adicionales</span>
          </div>

          <div class="flex flex-wrap gap-4">
            <!-- Operation Limit -->
            <div class="form-group flex-1 min-w-[220px]">
              <label
                for="operation_limit"
                class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1 min-h-[2.5rem]"
              >
                Límite por Operación
              </label>
              <div class="relative">
                <input
                  type="number"
                  id="operation_limit"
                  formControlName="operation_limit"
                  class="app-input pr-10"
                  placeholder="Sin límite"
                />
                <div class="input-icon">
                  <fa-icon [icon]="faGaugeHigh"></fa-icon>
                </div>
              </div>
              @if (form.get('operation_limit')?.touched && form.get('operation_limit')?.invalid) {
                <p class="error-text">El valor debe ser positivo</p>
              }
              <p class="hint-text">Importe sin IVA.</p>
            </div>

            <!-- Settlement Periodicity -->
            <div class="form-group flex-1 min-w-[220px]">
              <label
                for="settlement_periodicity"
                class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1 min-h-[2.5rem]"
              >
                Periodicidad Liquidación
              </label>
              <app-custom-select
                id="settlement_periodicity"
                formControlName="settlement_periodicity"
                [options]="settlementPeriodicityOptions"
                [small]="true"
                [showIcon]="false"
                placeholder="-- Sin definir --"
              ></app-custom-select>
            </div>

            <!-- Minimum New Clients Per Year -->
            <div class="form-group flex-1 min-w-[220px]">
              <label
                for="min_new_clients_per_year"
                class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1 min-h-[2.5rem]"
              >
                Mín. Nuevos clientes / Año
              </label>
              <div class="relative">
                <input
                  type="number"
                  id="min_new_clients_per_year"
                  formControlName="min_new_clients_per_year"
                  class="app-input pr-10"
                  placeholder="Ej: 6"
                />
                <div class="input-icon">
                  <fa-icon [icon]="faUserPlus"></fa-icon>
                </div>
              </div>
              @if (
                form.get('min_new_clients_per_year')?.touched &&
                form.get('min_new_clients_per_year')?.invalid
              ) {
                <p class="error-text">El valor debe ser positivo</p>
              }
            </div>
          </div>
        }

        <!-- Footer -->
        <div class="modal-footer mt-6">
          <p class="required-legend">* Campo obligatorio</p>
          <button type="button" class="btn-cancel" (click)="onClose()">Cancelar</button>
          <button type="submit" class="btn-submit" [disabled]="isLoading || form.invalid">
            @if (isLoading) {
              <div class="spinner spinner-white"></div>
              <span>Guardando...</span>
            } @else {
              <fa-icon [icon]="faSave" class="mr-2"></fa-icon>
              <span>Guardar Cambios</span>
            }
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

@if (showRelationshipInfoModal) {
  <div class="modal-overlay">
    <div class="modal-container info-modal-container">
      <div class="modal-header">
        <div class="header-content">
          <div class="icon-wrapper">
            <fa-icon [icon]="faCircleInfo"></fa-icon>
          </div>
          <h2 class="modal-title">Modelos de Relación</h2>
        </div>
        <button class="btn-close" (click)="closeRelationshipInfoModal()">
          <fa-icon [icon]="faXmark"></fa-icon>
        </button>
      </div>

      <div class="modal-body">
        <div class="alert-info mb-4">
          <fa-icon [icon]="faCircleInfo" class="mr-2"></fa-icon>
          <p class="text-xs leading-relaxed">
            Al cambiar el modelo de relación se actualizará para todos los usuarios asociados.
          </p>
        </div>
        <dl class="relationship-type-list">
          <div class="relationship-type-item">
            <dt>Referenciador</dt>
            <dd>
              Únicamente identifica oportunidades y las deriva a SDi. Puede optar a una comisión
              del 10% del proyecto, pero nunca participa en el negocio recurrente.
            </dd>
          </div>
          <div class="relationship-type-item">
            <dt>Distribuidor</dt>
            <dd>
              Comercializa productos o servicios de SDi y puede participar o no en la implantación.
              Las condiciones económicas se regulan en su contrato de distribución y puede
              participar en el negocio recurrente.
            </dd>
          </div>
          <div class="relationship-type-item">
            <dt>Partner Estratégico</dt>
            <dd>
              Alianzas estratégicas que aportan valor al negocio, aunque no necesariamente exista
              una venta directa.
            </dd>
          </div>
        </dl>
      </div>
    </div>
  </div>
}
